// import { useLanguage } from './LanguageContext';
import simpleTranslations from './simpleTranslations';
import translations from './translations';

// export const translate = (key, language) => {
//   // const { language } = useLanguage();

//   return translations[language][key] || translations['en'][key];
// };

export const translate = (key, language) => {
  // First check if the key exists in simpleTranslations
  if (simpleTranslations[key] && simpleTranslations[key][language]) {
    return simpleTranslations[key][language];
  }

  // If not found in simpleTranslations or language not available, fallback to original translations
  return translations[language]?.[key] || translations['en']?.[key] || key;
};
